if (!customElements.get('cws-mega-menu')) {
  class CwsMegaMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-cws-item]'));
      this.backdrop = this.querySelector('[data-cws-backdrop]');
      this.timer = null;
      this.moved = [];
      this.hover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.items.forEach((item) => {
        const btn = item.querySelector('[data-cws-trigger]');
        const panel = item.querySelector('[data-cws-panel]');
        if (!btn || !panel) return;
        // Il pannello va nel body: cosi' non viene tagliato dagli stili dell'header (sticky, trasparente)
        btn.cwsPanel = panel;
        panel.setAttribute('data-cws-mm', '');
        this.moved.push(panel);
        document.body.appendChild(panel);
        btn.addEventListener('click', (e) => { e.preventDefault(); this.isOpen(btn) ? this.close() : this.open(btn); });
        if (this.hover) {
          item.addEventListener('pointerenter', () => this.schedule(() => this.open(btn), 80));
          item.addEventListener('pointerleave', () => this.schedule(() => this.close(), 220));
          panel.addEventListener('pointerenter', () => clearTimeout(this.timer));
          panel.addEventListener('pointerleave', () => this.schedule(() => this.close(), 220));
        }
      });
      if (this.backdrop) {
        this.backdrop.setAttribute('data-cws-mm', '');
        this.moved.push(this.backdrop);
        document.body.appendChild(this.backdrop);
        this.backdrop.addEventListener('click', () => this.close());
      }
      this.onKey = (e) => { if (e.key === 'Escape' && this.current) { const b = this.current; this.close(); b.focus(); } };
      this.onDoc = (e) => { if (this.current && !this.contains(e.target) && !this.current.cwsPanel.contains(e.target)) this.close(); };
      this.onResize = () => { if (this.current) this.place(); };
      document.addEventListener('keydown', this.onKey);
      document.addEventListener('click', this.onDoc);
      window.addEventListener('resize', this.onResize);
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDoc);
      window.removeEventListener('resize', this.onResize);
      (this.moved || []).forEach((p) => p.remove());
    }
    schedule(fn, ms) { clearTimeout(this.timer); this.timer = setTimeout(fn, ms); }
    isOpen(btn) { return btn.getAttribute('aria-expanded') === 'true'; }
    place() {
      // Il pannello si allinea alla larghezza del contenuto dell'header (larghezza pagina)
      const header = this.closest('#header-component, header') || this;
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      const row = header.querySelector('.header__columns') || header;
      const r = row.getBoundingClientRect();
      const root = document.documentElement.style;
      root.setProperty('--cws-mm-top', bottom + 'px');
      root.setProperty('--cws-mm-left', Math.round(r.left) + 'px');
      root.setProperty('--cws-mm-width', Math.round(r.width) + 'px');
    }
    open(btn) {
      if (this.current === btn) return;
      this.close(true);
      this.place();
      const panel = btn.cwsPanel;
      panel.hidden = false;
      if (this.backdrop) this.backdrop.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => panel.classList.add('is-open'));
      this.current = btn;
    }
    close(immediate) {
      const btn = this.current;
      if (!btn) return;
      const panel = btn.cwsPanel;
      btn.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      if (this.backdrop) this.backdrop.hidden = true;
      this.current = null;
      if (immediate) panel.hidden = true;
      else setTimeout(() => { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 220);
    }
  }
  customElements.define('cws-mega-menu', CwsMegaMenu);
}

if (!customElements.get('cws-mega-drawer')) {
  class CwsMegaDrawer extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-cws-open]');
      this.drawer = this.querySelector('.cws-mm-drawer');
      if (!this.btn || !this.drawer) return;
      // Il drawer va nel body: copre tutta la pagina anche con l'header trasparente o sticky
      this.drawer.setAttribute('data-cws-mm', '');
      document.body.appendChild(this.drawer);
      this.btn.addEventListener('click', () => this.open());
      this.drawer.querySelector('[data-cws-close]').addEventListener('click', () => this.close());
      this.drawer.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => this.close()));
      this.onKey = (e) => { if (e.key === 'Escape' && this.drawer && !this.drawer.hidden) this.close(); };
      document.addEventListener('keydown', this.onKey);
    }
    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      if (this.drawer) this.drawer.remove();
    }
    open() {
      this.drawer.hidden = false;
      document.documentElement.classList.add('cws-mm-lock');
      this.btn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.drawer.classList.add('is-open'));
      const c = this.drawer.querySelector('[data-cws-close]');
      if (c) c.focus();
    }
    close() {
      this.drawer.classList.remove('is-open');
      document.documentElement.classList.remove('cws-mm-lock');
      this.btn.setAttribute('aria-expanded', 'false');
      setTimeout(() => { this.drawer.hidden = true; }, 250);
    }
  }
  customElements.define('cws-mega-drawer', CwsMegaDrawer);
}
